export function price(value, locale, currency, options) {
    try {
        const localeCode = typeof locale === "string" ? locale : locale.localeCode;
        return new Intl.NumberFormat(localeCode, {
            style: "currency",
            currency,
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0,
            ...options
        }).format(value);
    }
    catch (e) {
        return `${value} ${currency}`;
    }
}
//# sourceMappingURL=price.js.map